import { ArcheidosKeyType } from '../../keys';

const archeidosKeys: ArcheidosKeyType = {
  archeidos: 'Archeidos',
  characterEnchancer: 'Character enchancer',
  completed: 'Completed',
  generalEnchancer: 'General enchancer',
  generationStarted: 'Generation started..',
  lockStrength: 'Lock strength',
  originalRetention: 'Original retention',
  prompt: 'Prompt',
  seed: 'Seed',
  sourceImage: 'Source image',
  steps: 'Steps',
  styleTransfer: 'Style transfer',
  transfersTheVisualStyleFromOneImageToAnotherWhilePreservingTheContentAndCompositionOfTheOriginalImageIdealForApplyingaSpecificColorSchemeLightingOrArtisticStyle:
    'Transfers the visual style from one image to another while preserving the content and composition of the original image. Ideal for applying a specific color scheme, lighting, or artistic style.'
};

export default archeidosKeys;
